export enum FishFeedType {
  STARTER = 'starter',
  PRODUCTION = 'production',
  REPRODUCTION = 'reproduction',
  OTHER = 'other',
}
